function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
var TextTrackCueList = function () {
    function TextTrackCueList(cues) {
        _classCallCheck(this, TextTrackCueList);
        TextTrackCueList.prototype.setCues_.call(this, cues);
        Object.defineProperty(this, 'length', {
            get: function get() {
                return this.length_;
            }
        });
    }
    _createClass(TextTrackCueList, [
        {
            key: 'setCues_',
            value: function setCues_(cues) {
                var oldLength = this.length || 0;
                var i = 0;
                var l = cues.length;
                this.cues_ = cues;
                this.length_ = cues.length;
                var defineProp = function defineProp(index) {
                    if (!('' + index in this)) {
                        Object.defineProperty(this, '' + index, {
                            get: function get() {
                                return this.cues_[index];
                            }
                        });
                    }
                };
                if (oldLength < l) {
                    i = oldLength;
                    for (; i < l; i++) {
                        defineProp.call(this, i);
                    }
                }
            }
        },
        {
            key: 'getCueById',
            value: function getCueById(id) {
                var result = null;
                for (var i = 0, l = this.length; i < l; i++) {
                    var cue = this[i];
                    if (cue.id === id) {
                        result = cue;
                        break;
                    }
                }
                return result;
            }
        }
    ]);
    return TextTrackCueList;
}();
export default TextTrackCueList;